const getters = {
    headerActiveId: state => state.public.headerActiveId,
    isMobile: state => state.public.isMobile,
    isShowLoginModal: state => state.public.isShowLoginModal,
    schoolConfigInfo: state => state.public.schoolConfiInfo,
}
export default getters